import { ComponentType, FunctionComponent, useContext } from "react";
import { Subtract } from "utility-types";
import { ConfigurationContext } from "./ConfigurationContext";
import { IWithConfigurationProps } from "./IWithConfigurationProps";

export function WithConfiguration<P extends IWithConfigurationProps>(
  Component: ComponentType<P>
): FunctionComponent<Subtract<P, IWithConfigurationProps>> {
  function ComponentWithConfiguration(props: Subtract<P, IWithConfigurationProps>) {
    const config = useContext(ConfigurationContext);
    return <Component {...(props as P)} config={config} isConfigReady={config?.isInitialized ?? false} />;
  }

  const componentName = Component.displayName ?? Component.name ?? `Component`;
  ComponentWithConfiguration.displayName = `WithConfiguration(${componentName})`;

  return ComponentWithConfiguration;
}
